const t = {
  code: "th",
  facebook: "th_TH",
  label: "ไทย",
  loadingText: "กำลังโหลด...",
  translations: {
    ar: "ภาษาอาหรับ",
    de: "ภาษาเยอรมัน",
    en: "ภาษาอังกฤษ",
    es: "ภาษาสเปน",
    fr: "ภาษาฝรั่งเศส",
    he: "ภาษาฮีบรู",
    hi: "ภาษาฮินดี",
    id: "ภาษาอินโดนีเซีย",
    it: "ภาษาอิตาลี",
    ja: "ภาษาญี่ปุ่น",
    km: "ภาษาเขมร",
    ko: "ภาษาเกาหลี",
    lo: "ภาษาลาว",
    ms: "ภาษามาเลย์",
    nl: "ภาษาดัทช์",
    pt: "ภาษาโปรตุเกส",
    ru: "ภาษารัสเซีย",
    th: "ภาษาไทย",
    tl: "ภาษาฟิลิปิโน",
    tr: "ภาษาตุรกี",
    vi: "ภาษาเวียดนาม",
    "zh-CN": "ภาษาจีน (ตัวย่อ)",
    "zh-TW": "ภาษาจีน (ตัวเต็ม)"
  }
};
export {
  t as thai
};
